import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {LoadingService} from "../../services/LoadingService";
import {QuestionnairesSurveysService} from "../../services/questionnaires-surveys.service";
import {ErrorHandlerService} from "../../services/error-handler.service";
import {SnackBarService} from "../../services/snack-bar.service";
import {Session} from "../../services/Session";
import FroalaEditor from 'froala-editor';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {MatRadioModule} from "@angular/material/radio";
import {environment} from "../../../environments/environment";
import {MatButtonModule} from "@angular/material/button";

declare var jQuery: any;

export interface DialogData {
  firstName: string;
  lastName: string;
  clientName: string;
  clientId: string;
  email: string;
  subject: string;
  mailBody: string;
  questionnaireMetadata: any;
  questionnaireName: string;
  resend: boolean;
  portalEnabled: boolean;
}

@Component({
  selector: 'app-qs-securelink-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatRadioModule, MatButtonModule],
  templateUrl: './qs-securelink-dialog.component.html',
  styleUrl: './qs-securelink-dialog.component.scss'
})
export class QsSecurelinkDialogComponent implements OnInit {
  org: string;
  userId: string;
  loader: boolean;
  copyUrl: string;
  respondVia: string;
  email: string;
  customEmail: string;
  mailSubject: string;
  editorObj = {
    heightMin: 160,
    autofocus: false,
    listAdvancedTypes: false,
    linkAlwaysBlank: true,
    enter: FroalaEditor.ENTER_DIV,
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    inlineMode: false,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'textColor', 'formatOL', 'formatUL', 'align'],
    toolbarSticky: true,
    toolbarBottom: false,
    toolbarStickyOffset: 10,
    placeholderText: 'Type Your Content Here ...',
    charCounterCount: false,
    quickInsertTags: [],
    attribution: false,
    linkList: [
      {
        text: 'Google',
        href: 'http://google.com',
        target: '_blank',
        rel: 'nofollow'
      }
    ],
    zIndex: 999,
    theme: 'royal',
    fontSize: ['8', '10', '12', '14', '15', '16', '18'],
    fontSizeDefaultSelection: '15',
    fontFamilySelection: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {
      'Poppins-Regular': 'poppins',
      NiveauGrotesk: 'NiveauGrotesk',
      Karla: 'Karla',
      'Roboto,sans-serif': 'Roboto',
      'Oswald,sans-serif': 'Oswald',
      'Montserrat,sans-serif': 'Montserrat',
      '\'Open Sans Condensed\',sans-serif': 'Open Sans Condensed',
      'Arial,Helvetica,sans-serif': 'Arial',
      'Georgia,serif': 'Georgia',
      'Impact,Charcoal,sans-serif': 'Impact',
      'Tahoma,Geneva,sans-serif': 'Tahoma',
      '\'Times New Roman\',Times,serif': 'Times New Roman',
      'Verdana,Geneva,sans-serif': 'Verdana'
    },
    imageUploadRemoteUrls: false,
  };
  mailBody: string = '';
  showErrorForPortal: boolean = false;
  showErrorForEmail: boolean = false;
  currentEnvironment: any;

  constructor(
    public dialogRef: MatDialogRef<QsSecurelinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private snackBar: SnackBarService,
    private loadingService: LoadingService,
    private errorHandlerService: ErrorHandlerService,
    private questionnairesSurveysService: QuestionnairesSurveysService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.currentEnvironment = environment;
    this.data.clientName = this.data.firstName + ' ' + this.data.lastName;
    this.respondVia = 'portal';
    this.email = this.data.email;
    this.customEmail = '';
  }

  copyLink(contact, type): void {
    // Native public form via the shared helper, so the send dialog and the
    // organizer table build the identical link (CU-868kq8bx5). The token lives
    // in contact.uuid; the retired forms.taxplaniq.com host is dead.
    this.copyUrl = this.questionnairesSurveysService.getPublicFormUrl(this.org, contact.uuid);
    if (type === 'copy') {
      setTimeout( () => {
        jQuery('#secureCopy').select();
        document.execCommand('copy');
        this.snackBar.showNotification('URL Copied', 'info');
      });
    } else {
      window.open(this.copyUrl, '_blank');
    }
  }

  sendQuestionnaire(){
    const request: any = {
      id: '',
      organizerId: this.data.questionnaireMetadata.questionnaireId,
      organizerName: this.data.questionnaireName,
      // bucketId: this.data.questionnaireMetadata.buckets ? this.data.questionnaireMetadata.buckets[0].bucketKey : '',
      // bucketName: this.data.questionnaireMetadata.buckets ? this.data.questionnaireMetadata.buckets[0].bucketvalue : '',
      clientId: this.data.clientId,
      clientName: this.data.clientName,
      type: 'externalLink',
      secured: this.respondVia !== 'portal',
      internalContacts: [],
      externalContacts: this.getContacts(),
      mail: {
        subject: this.mailSubject,
        body: this.mailBody
      },
      sourceId: this.data.clientId
    };
    if (this.respondVia == 'portal' && !this.data.portalEnabled) {
      this.showErrorForPortal = true;
    } else if (this.respondVia == 'external' && !this.email) {
      this.showErrorForEmail = true;
    } else if (this.respondVia == 'custom' && !this.customEmail) {
      this.showErrorForEmail = true;
    } else {
      this.loadingService.triggerLoadingEvent(true);
      this.questionnairesSurveysService.sendQuestionnaireToClient(this.org, this.userId, request, this.data.resend).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.questionnairesSurveysService.clearQuestionnaireData();
        this.dialogRef.close();
        this.snackBar.showNotification('Questionnaire sent successfully', 'Success');
      }, error => {
        this.handleError(error);
      });
    }
  }

  setPortalErrorMessage() {
    this.showErrorForEmail = false;
    if (this.respondVia !== 'portal') {
      this.showErrorForPortal = false;
    }
  }

  handleError(error): void {
    this.loadingService.triggerLoadingEvent(false);
    this.errorHandlerService.handleError(error);
  }

  getContacts() {
    const contacts: any = [];
    if (this.respondVia === 'custom') {
      contacts.push({
        firstName: '',
        lastName: '',
        email: this.customEmail
      });
    } else {
      contacts.push({
        firstName: this.data.firstName,
        lastName: this.data.lastName,
        email: this.email
      });
    }
    return contacts;
  }

}
